/* CDN colour image swatches (47brand-style). PDP-only, self-guarding, no deps.
   Restyles the COLOUR variant option's radio labels into square photo tiles,
   reuses the theme's hidden radios + native change. Map on window.CDN_VARIANT_SWATCHES.
   Also echoes the selected colour name into the option heading ("COLOR: Navy"),
   like the 47brand reference, kept live on selection.

   Theme gotchas handled (both from `... input:checked + label{background:var(--cdn-text)!important}`):
   1) the `background` SHORTHAND resets background-size to auto (outranks .cdn-swatch),
      shrinking the hat into the tile corner = looked blank. We pin size/position/
      repeat INLINE !important.
   2) the theme strips inline styles off the label it selects — incl. the first colour
      it selects programmatically on load (no 'change' event). A MutationObserver
      re-paints any blanked swatch (init/click/re-render).
*/
(function () {
  var MAP_KEY = 'CDN_VARIANT_SWATCHES';

  var NAMED = {
    black: '#1a1a1a', white: '#ffffff', natural: '#efe8d8', red: '#c0392b',
    navy: '#1f2a44', 'dark navy': '#172036', 'royal blue': '#1f4fd1',
    blue: '#2f5fd0', silver: '#c8cdd2', grey: '#9aa0a6', gray: '#9aa0a6',
    'dark grey': '#5a5f64', 'dark gray': '#5a5f64', 'heather grey': '#b7bcc2',
    'heather gray': '#b7bcc2', heather: '#b7bcc2', spruce: '#2f4a3f',
    green: '#2e7d4f', charcoal: '#36393d', tan: '#d2b48c', cream: '#f3ead7',
    pink: '#e59ab0', purple: '#6c4d9e', orange: '#e2772e', yellow: '#e8c33c',
    gold: '#caa53d', maroon: '#6e2230', olive: '#6b6f3a', brown: '#6b4a2f', teal: '#2a7d7d'
  };

  function chipColour(name) {
    if (!name) return null;
    var key = String(name).toLowerCase().trim();
    var first = key.split('/')[0].replace(/\s+/g, ' ').trim();
    if (NAMED[key]) return NAMED[key];
    if (NAMED[first]) return NAMED[first];
    var words = first.split(' ');
    for (var i = words.length - 1; i >= 0; i--) { if (NAMED[words[i]]) return NAMED[words[i]]; }
    return null;
  }

  function looksLikeColour(group) {
    var radio = group.querySelector('input[type="radio"]');
    var nm = (radio && radio.name) || group.getAttribute('name') || '';
    return /colou?r/i.test(nm);
  }

  function styleLabel(label, map) {
    if (label.classList.contains('single-option-radio__label')) return; // option heading
    var value = (label.textContent || '').trim() || label.getAttribute('data-cdn-colour') || '';
    if (!value) return;
    label.setAttribute('data-cdn-colour', value);
    label.classList.add('cdn-swatch');
    if (label.getAttribute('title') !== value) label.setAttribute('title', value);
    if (label.getAttribute('aria-label') !== value) label.setAttribute('aria-label', value);

    if (!label.querySelector('.cdn-swatch__name')) {
      var span = document.createElement('span');
      span.className = 'cdn-swatch__name';
      span.textContent = value;
      var nodes = Array.prototype.slice.call(label.childNodes);
      nodes.forEach(function (n) { if (n.nodeType === 3) label.removeChild(n); });
      label.appendChild(span);
    }

    var entry = map && map[value];
    var imageUrl = entry && entry.image;
    if (imageUrl) {
      var desired = 'url("' + imageUrl + '")';
      var current = label.style.getPropertyValue('background-image');
      if (current.indexOf(imageUrl) === -1) {
        label.style.setProperty('background-image', desired, 'important');
      }
      label.style.setProperty('background-size', 'cover', 'important');
      label.style.setProperty('background-position', 'center center', 'important');
      label.style.setProperty('background-repeat', 'no-repeat', 'important');
      label.classList.remove('cdn-swatch--chip');
      label.classList.remove('cdn-swatch--chip-neutral');
    } else {
      var c = chipColour(value);
      label.classList.add('cdn-swatch--chip');
      label.style.setProperty('background-image', 'none', 'important');
      if (c) { label.style.setProperty('background-color', c, 'important'); }
      else { label.classList.add('cdn-swatch--chip-neutral'); }
    }
  }

  function attachGroup(group, map) {
    var observer = null;
    var applying = false;

    // Option heading ("Color") lives in the sibling .radio-wrapper. We append the
    // selected colour name to it: "COLOR: Navy".
    var wrapper = group.closest('.radio-wrapper');
    var heading = wrapper ? wrapper.querySelector('.single-option-radio__label') : null;
    if (heading && heading.getAttribute('data-cdn-label') === null) {
      heading.setAttribute('data-cdn-label', (heading.textContent || 'Colour').replace(/:\s*$/, '').trim());
    }

    function updateHeading() {
      if (!heading) return;
      var base = heading.getAttribute('data-cdn-label') || 'Colour';
      var checked = group.querySelector('input[type="radio"]:checked');
      var val = checked ? (checked.value || '') : '';
      var span = heading.querySelector('.cdn-swatch-selected-value');
      if (!span) {
        heading.textContent = base + ': ';
        span = document.createElement('span');
        span.className = 'cdn-swatch-selected-value';
        span.style.cssText = 'font-weight:400;text-transform:none;letter-spacing:normal;';
        heading.appendChild(span);
      }
      if (span.textContent !== val) span.textContent = val; // textContent = XSS-safe
    }

    function apply() {
      if (applying) return;
      applying = true;
      if (observer) observer.disconnect();
      group.classList.add('cdn-swatch-grid');
      Array.prototype.forEach.call(group.querySelectorAll('label'), function (l) { styleLabel(l, map); });
      updateHeading();
      if (observer) {
        observer.observe(group, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class'] });
      }
      applying = false;
    }

    observer = new MutationObserver(function () {
      if (applying) return;
      window.requestAnimationFrame(apply);
    });

    apply();

    group.addEventListener('change', function () {
      apply();
      updateHeading();
      syncMobileGallery();
      setTimeout(function () { apply(); syncMobileGallery(); }, 0);
    });
  }

  function buildSwatches(map) {
    var groups = document.querySelectorAll('#productTop .single-option-radio[data-option]');
    if (!groups.length) return;
    Array.prototype.forEach.call(groups, function (group) {
      if (!looksLikeColour(group)) return;
      if (group.getAttribute('data-cdn-swatches') === '1') return;
      group.setAttribute('data-cdn-swatches', '1');
      attachGroup(group, map);
    });
  }

  function currentVariantImageId() {
    try {
      var json = document.querySelector('[data-product-form] script[data-product-json]');
      var sel = document.querySelector('select.product-single__variants, select[name="id"]');
      if (!json || !sel) return null;
      var product = JSON.parse(json.textContent);
      var id = parseInt(sel.value, 10);
      var v = product.variants.filter(function (x) { return x.id === id; })[0];
      return v && v.featured_image ? v.featured_image.id : null;
    } catch (e) { return null; }
  }

  function syncMobileGallery() {
    if (window.innerWidth > 899) return;
    var imgId = currentVariantImageId();
    if (!imgId) return;
    var track = document.querySelector('#productTop .productImages .image-container');
    if (!track) return;
    var slides = track.querySelectorAll(':scope > img.productImage');
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute('data-image-id')) === String(imgId)) {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        return;
      }
    }
  }

  function init() {
    if (!document.querySelector('#productTop')) return; // PDP-only
    var map = window[MAP_KEY];
    if (!map || typeof map !== 'object') return;
    if (!Object.keys(map).length) return;

    var tries = 0;
    (function wait() {
      var groups = document.querySelectorAll('#productTop .single-option-radio[data-option]');
      var found = false;
      Array.prototype.forEach.call(groups, function (g) { if (looksLikeColour(g)) found = true; });
      if (found) { buildSwatches(map); return; }
      if (tries++ < 40) setTimeout(wait, 80);
    })();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
